import * as Combobox from '@givebutter/primitives/combobox';
import { ListItemGroupProps } from 'components/filter/types-legacy';
import { capitalize, toLower } from 'lodash';
import { LetterFulfillmentMailStatus } from 'types/domain';

const MailingsTrackableOptions = () => (
    <>
        <MailingTrackableOption status="Received" />
        <MailingTrackableOption status="In Production" />
        <MailingTrackableOption status="Mailed" />
        <MailingTrackableOption status="In Transit" />
        <MailingTrackableOption status="In Local Area" />
        <MailingTrackableOption status="Processed for Delivery" />
        <MailingTrackableOption status="Re-Routed" />
        <MailingTrackableOption status="Returned to Sender" />
        <MailingTrackableOption status="Delivered" />
        <MailingTrackableOption status="Failed" />
    </>
);

interface MailingTrackableOptionProps extends ListItemGroupProps {
    status: LetterFulfillmentMailStatus;
}

const MailingTrackableOption = ({ status }: MailingTrackableOptionProps) => (
    <Combobox.Item value={status}>
        <Combobox.CheckboxIndicator />
        <Combobox.ItemText>{capitalize(toLower(status))}</Combobox.ItemText>
    </Combobox.Item>
);

export { MailingsTrackableOptions };
